module.exports = "https://static.wmbcdn.com/uniweb/images/ad81d1f76f0847a70bd0d666e684bdb0.svg";